import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import PostsIcon from '@mui/icons-material/ChromeReaderMode';
import PublishIcon from '@mui/icons-material/Create';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HelpIcon from '@mui/icons-material/Help';
import MonetizationIcon from '@mui/icons-material/MonetizationOn';
import DraftIcon from '@mui/icons-material/FileCopy';
import FlagIcon from '@mui/icons-material/Flag';
import HostingIcon from '@mui/icons-material/Http';
import InboxIcon from '@mui/icons-material/Inbox';
import MailIcon from '@mui/icons-material/Mail';
import VideoIcon from '@mui/icons-material/MovieCreation';
import PaymentIcon from '@mui/icons-material/Payment';
import ProfileIcon from '@mui/icons-material/Person';
import UserAddIcon from '@mui/icons-material/PersonAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import StarIcon from '@mui/icons-material/Star';
import VerifiedIcon from '@mui/icons-material/Verified';
import { getRoles } from '../../helpers/token';
import DashboardMenuItem from './DashboardMenuItem';
import { useQuery } from '@apollo/client';
import { UNREAD_COUNT } from '../../helpers/graphql/unread';
import UserContext from '../General/UserContext';
import React, { useContext, useEffect } from 'react';

export default function DashboardMenuItems({
  active,
  open,
  unreadCountOffset,
}) {
  const roles = getRoles();

  const { data, refetch } = useQuery(UNREAD_COUNT, { ssr: false });

  useEffect(() => {
    async function doReFetch() {
      await new Promise(r => setTimeout(r, 500));
      refetch();
    }
    if (unreadCountOffset) {
      console.log(unreadCountOffset);
      doReFetch().catch(err => console.error(err));
    }
  }, [refetch, unreadCountOffset]);

  const { theme } = useContext(UserContext);
  const isDarkTheme = theme === 'dark';

  return (
    <>
      <List>
        <DashboardMenuItem
          page="dashboard"
          link=""
          active={active}
          open={open}
          Icon={DashboardIcon}
        />
        <DashboardMenuItem
          page="publish"
          active={active}
          open={open}
          Icon={PublishIcon}
        />
        <DashboardMenuItem
          page="drafts"
          active={active}
          open={open}
          Icon={DraftIcon}
        />
        <DashboardMenuItem
          page="posts"
          active={active}
          open={open}
          Icon={PostsIcon}
        />
        {/* Problem: Icon needs to turn green when active! */}
        <DashboardMenuItem
          page="aiblogger"
          active={active}
          open={open}
          iconComponent={
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19px"
                height="16px"
              >
                <path
                  stroke={
                    active === 'aiblogger'
                      ? '#3A8579'
                      : isDarkTheme
                      ? '#F6F6F6'
                      : '#6E6F70'
                  }
                  fill={
                    active === 'aiblogger'
                      ? '#3A8579'
                      : isDarkTheme
                      ? '#F6F6F6'
                      : '#6E6F70'
                  }
                  d="M16.904,15.137 L16.904,0.008 L19.006,0.008 L19.006,15.137 L16.904,15.137 ZM10.620,10.555 L3.978,10.555 L2.233,15.137 L0.001,15.137 L6.102,0.008 L8.366,0.008 L14.867,15.137 L12.473,15.137 L10.620,10.555 ZM8.312,4.735 C7.806,3.462 7.431,2.416 7.185,1.598 C6.983,2.568 6.697,3.531 6.329,4.487 L4.585,8.925 L9.970,8.925 L8.312,4.735 Z"
                />
              </svg>
            </div>
          }
          title="AI Blogger"
        />
        <DashboardMenuItem
          page="video"
          active={active}
          open={open}
          Icon={VideoIcon}
        />
      </List>
      <Divider />
      <List>
        <DashboardMenuItem
          page="inbox"
          active={active}
          open={open}
          Icon={InboxIcon}
          unreadCount={data && data.unreadCount}
        />
        <DashboardMenuItem
          page="profile"
          active={active}
          open={open}
          Icon={ProfileIcon}
        />
        <DashboardMenuItem
          page="upgrade"
          active={active}
          open={open}
          Icon={
            roles && roles.indexOf('paid') !== -1 ? PaymentIcon : VerifiedIcon
          }
          title={
            roles && roles.indexOf('paid') !== -1 ? 'Billing' : 'Get Verified'
          }
        />
        <DashboardMenuItem
          page="hosting"
          active={active}
          open={open}
          Icon={HostingIcon}
        />
        <DashboardMenuItem
          isNoDashboard
          page="monetization"
          link="/how-to-make-money-with-a-travel-blog"
          active={active}
          open={open}
          Icon={MonetizationIcon}
        />
        <DashboardMenuItem
          isNoDashboard
          page="help"
          link="/help"
          active={active}
          open={open}
          Icon={HelpIcon}
        />
        <DashboardMenuItem
          page="settings"
          active={active}
          open={open}
          Icon={SettingsIcon}
        />
        <DashboardMenuItem
          page="contest"
          active={active}
          open={open}
          Icon={UserAddIcon}
          title="Refer a friend"
        />
      </List>
      {roles && roles.indexOf('curator') !== -1 && (
        <>
          <Divider />
          <List>
            <DashboardMenuItem
              page="curation"
              active={active}
              open={open}
              Icon={StarIcon}
            />
          </List>
        </>
      )}
      {roles && roles.indexOf('team') !== -1 && (
        <>
          <Divider />
          <List>
            <DashboardMenuItem
              page="newsletter"
              active={active}
              open={open}
              Icon={MailIcon}
            />
            <DashboardMenuItem
              page="reports"
              active={active}
              open={open}
              Icon={FlagIcon}
            />
          </List>
        </>
      )}
    </>
  );
}
